<template>
  <div>
    <b-row  class="m-3"  >
      <b-col  v-for="(field,index) in fields" :key="index" :md="field.col">
        <FilterWidget
        
          v-bind:parentKey="parentKey"
          @filter-change="onFilterChange"
          v-bind:field="field"
          
        ></FilterWidget>
         
      </b-col>
       <b-col md="2" >
        <b-button v-if="isDynamic" variant="primary" @click="onFilterChangeClick">{{$t('confirm')}}</b-button>
      </b-col>
      
    </b-row>
   
  </div>
</template>

<script>
import FilterWidget from "./FilterWidget";

export default {
  components: {
    FilterWidget
  },

  props: {
    fields: {
      type: Array,
      required: true
    },

    isDynamic: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  data() {
    return {
      parentKey: {},
      fieldData: {}
    };
  },


  methods: {
    onFilterChangeClick() {
       var  filterData={};
               filterData.isDynamic=true;
               filterData.fieldData=this.fieldData;
      this.$emit("filter-change",filterData);
    },
    onFilterChange(e) {
      //  console.log(JSON.stringify(e));
      
      if (e.parentKey == "") {
        this.parentKey = {
          key: e.key,
          value: e.value
        };
      }

      this.fieldData[e.key] = e.value;
      //console.log(JSON.stringify(this.fieldData));


      if (!this.isDynamic) {
               var  filterData={};
               filterData.isDynamic=false;
               filterData.fieldData=this.fieldData;
        this.$emit("filter-change", filterData);
      }
    }
  }
};
</script>